(function() {
  'use strict';

  angular
    .module('app.organization')
    .factory('UserInvitationService', UserInvitationService);

  UserInvitationService.$inject = [
    '$state',
    '$rootScope',
    'APP_CONSTANTS',
    'ApiCaller',
    '$window',
    '$stateParams',
    '$q',
    '$filter'
  ];

  function UserInvitationService(
    $state,
    $rootScope,
    APP_CONSTANTS,
    ApiCaller,
    $window,
    $stateParams,
    $q,
    $filter
  ) {
    var vm = this;

    vm.selectedRole = [];
    vm.selectedRolesId = [];
    vm.selectRole = selectRole;
    vm.sendInvite = sendInvite;
    vm.fetchUsersList = fetchUsersList;
    vm.grantOrRevokeUser = grantOrRevokeUser;

    function fetchUsersList(sponsoredOrganizationId) {
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.usersByCustomerId,
        APP_CONSTANTS.rootUrl,
        sponsoredOrganizationId
      );

      ApiCaller.apiGet(url).then(
        function(result) {
          deferred.resolve(result);
        },
        function(err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    function selectRole(role) {
      var id = vm.selectedRolesId.indexOf(role.id);

      if (id > -1) {
        vm.selectedRolesId.splice(id, 1);
        vm.selectedRole.splice(role, 1);
      } else {
        vm.selectedRolesId.push(role.id);
        vm.selectedRole.push(role);
      }
    }

    function grantOrRevokeUser(user) {
      var deferred = $q.defer();
      var url = '';
      var originalStatus = user.status;

      if (user.status) {
        url = $filter('sprintf')(
          APP_CONSTANTS.userGrant,
          APP_CONSTANTS.rootUrl,
          user.id
        );
      } else {
        url = $filter('sprintf')(
          APP_CONSTANTS.userRevoke,
          APP_CONSTANTS.rootUrl,
          user.id
        );
      }

      ApiCaller.apiPost(url, {}).then(
        function(result) {
          user.status = !user.status;
          deferred.resolve(result);
        },
        function(err) {
          user.status = originalStatus;
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    function sendInvite(user) {
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.sponsoredOrganizationUserInvitation,
        APP_CONSTANTS.rootUrl
      );

      ApiCaller.apiPost(url, user).then(
        function(result) {
          deferred.resolve(result);
        },
        function(err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    return vm;
  }
})();
